
import { Badge } from "@/components/ui/badge";

interface ProjectHeaderProps {
  name: string;
  isArchived: boolean;
}

export function ProjectHeader({ name, isArchived }: ProjectHeaderProps) {
  return (
    <div className="space-y-2 mb-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-accent-purple-700">{name || "New Project"}</h1>
          <p className="text-accent-blue-600 text-sm">
            Manage your project details here.
          </p>
        </div>
        <Badge 
          variant={isArchived ? "destructive" : "default"} 
          className={`
            ${isArchived 
              ? "bg-accent-teal-700 text-white hover:bg-accent-teal-800" 
              : "bg-accent-purple-100 text-accent-purple-700 hover:bg-accent-purple-200"}
          `}
        >
          {isArchived ? "Archived" : "Active"}
        </Badge>
      </div>
    </div>
  );
}
